<template>
	<div class="error-page">
		<div class="text">
			<p>404</p>
			<p>{{$t('404.desc')}}</p>
			<router-link to="/" class="small-btn hollow">{{$t('404.back')}}</router-link>
		</div>
	</div>
</template>

<script>
export default {
	name: "Error"
}
</script>

<style scoped lang="scss">
//error-page
.error-page {
	padding: 100px 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
	p {
		@extend .title1;
	}
	p + p {
		margin-top: 16px;
	}
	.small-btn {
		margin-top: 44px;
	}
}
</style>
